export default {
    FormData: {},
    resHeisenData: {},
  };